<template>
  <div class="subscribe" :style="{backgroundColor:backgroundColor || '#ff3c00'}">
    <img :src="image" alt="">
    <p :style="{color:color || '#fff'}">
      {{description}}
    </p>
    <form @submit.prevent="subscribe">
      <input type="email" required placeholder="填写您的E-mail地址" v-model="email">
      <button>订阅 ></button>
    </form>
  </div>
</template>

<script>
  import axios from 'axios';
  import { mapState } from 'vuex';

  export default {
    name: 'Subscribe',
    data() {
      return {
        email: ''
      };
    },
    computed: {
      ...mapState({
        backgroundColor: state => state.subscribe.backgroundColor,
        image: state => state.subscribe.image,
        description: state => state.subscribe.description,
        color: state => state.subscribe.color,
        contentType: state => state.subscribe.contentType,
        activityId: state => state.subscribe.activityId,
      })
    },
    methods: {
      subscribe() {
        axios.post('https://events.geekpark.net/api/v1/involvers', {
          email: this.email,
          content_type: this.contentType,
          activity_id: this.activityId
        })
          .then(() => {
            alert(`邮箱 ${this.email} 已订阅成功`);
            this.email = '';
          })
          .catch((error) => {
            if (error.response.status === 422) {
              alert(`邮箱 ${this.email} 已经订阅过了~`);
            } else {
              alert('网络有点问题~');
            }
          });
        return false;
      }
    }
  };
</script>

<style scoped lang="less">
  .subscribe {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 70vh;
    height: 100%;
    padding: 7vh 6vh 13vh 6vh;
    margin-left: 5vh;
  }

  img {
    display: block;
    width: 100%;
  }

  p {
    width: 90%;
    margin: 3vh 0 5vh 0;
    text-align: justify;
    font-size: 2.5vh;
    font-weight: 100;
  }

  form {
    display: flex;
    justify-content: space-between;

    input {
      box-sizing: border-box;
      padding-left: 2vh;
      width: 42vh;
      height: 6vh;
      border: none;
      background: #ffffff;
      font-size: 2.5vh;
      border-radius: 0;
    }

    button {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 15vh;
      border: none;
      color: #fff;
      background-color: #000;
      font-size: 3vh;

      &:hover {
        cursor: pointer;
      }
    }
  }
</style>
